const CarrierLookup = () => {
  return (
    <svg
      className="-mt-1 w-5 h-5 text-[#fff] overflow-hidden vertical-align-middle"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1006.933333 191.146667C877.226667 68.266667 703.146667 0 512 0h-6.826667C314.026667 0 153.6 61.44 17.066667 191.146667 
              6.826667 204.8 0 218.453333 0 232.106667c0 17.066667 6.826667 34.133333 17.066667 40.96l98.986666 122.88c10.24 10.24 
              27.306667 17.066667 40.96 17.066666 17.066667 0 30.72-6.826667 40.96-17.066666 27.306667-23.893333 61.44-40.96 
              95.573334-58.026667l20.48-10.24c20.48-10.24 27.306667-34.133333 27.306666-54.613333V133.12c58.026667-20.48 
              105.813333-30.72 167.253334-30.72h3.413333c54.613333 0 109.226667 10.24 170.666667 30.72v133.12c0 27.306667 
              10.24 47.786667 27.306666 58.026667l23.893334 10.24c34.133333 17.066667 75.093333 37.546667 98.986666 61.44 
              23.893333 20.48 58.026667 20.48 81.92-3.413334l88.746667-116.053333c13.653333-13.653333 20.48-27.306667 
              20.48-44.373333 0-13.653333-6.826667-27.306667-17.066667-40.96z"
        fill="#fff"
      ></path>
      <path
        d="M290.133333 529.066667m-85.333333 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"
        fill="#fff"
      ></path>
      <path
        d="M529.066667 529.066667m-85.333334 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"
        fill="#fff"
      ></path>
      <path
        d="M768 529.066667m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z"
        fill="#fff"
      ></path>
      <path
        d="M290.133333 733.866667m-85.333333 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"
        fill="#fff"
      ></path>
      <path
        d="M529.066667 733.866667m-85.333334 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"
        fill="#fff"
      ></path>
      <path
        d="M768 733.866667m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z"
        fill="#fff"
      ></path>
      <path
        d="M290.133333 938.666667m-85.333333 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"
        fill="#fff"
      ></path>
      <path
        d="M529.066667 938.666667m-85.333334 0a85.333333 85.333333 0 1 0 170.666667 0 85.333333 85.333333 0 1 0-170.666667 0Z"
        fill="#fff"
      ></path>
      <path
        d="M768 938.666667m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z"
        fill="#fff"
      ></path>
    </svg>
  );
};

export default CarrierLookup;
